module.exports = __webpack_public_path__ + "img/brand-dimsumthinking.d1fec4f0.svg";